<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { useWindowSize } from '@vueuse/core';

const subtitleElement = ref(null);
const introElement = ref(null);

const { width } = useWindowSize();

let resizeObserver = null;

const updateSpacing = () => {
    if (!introElement.value) return;

    if (width.value < 1024) {
        introElement.value.style.paddingTop = null;
        return;
    }

    if (subtitleElement.value) {
        const subtitleHeight = subtitleElement.value.offsetHeight;
        introElement.value.style.paddingTop = `${subtitleHeight}px`;
    }
};

onMounted(() => {
    // Find elements by data attributes
    subtitleElement.value = document.querySelector('[data-subtitle]');
    introElement.value = document.querySelector('[data-intro]');

    if (subtitleElement.value && introElement.value) {
        // Initial spacing calculation
        updateSpacing();

        // Create ResizeObserver to watch for subtitle height changes
        resizeObserver = new ResizeObserver(() => {
            updateSpacing();
        });

        // Observe subtitle element for size changes
        resizeObserver.observe(subtitleElement.value);

        // Also listen for window resize
        window.addEventListener('resize', updateSpacing);
    }
});

onUnmounted(() => {
    if (resizeObserver) {
        resizeObserver.disconnect();
    }
    window.removeEventListener('resize', updateSpacing);
});
</script>

<template />
